import { createSlice } from "@reduxjs/toolkit";

const CountSlice = createSlice({
  name: "count",
  initialState: {
    value: 0,
  },
  reducers: {
    IncreaseCount: (state, action) => {
      state.value = action.payload;
    },
    DecreaseCount: (state, action) => {
      state.value = action.payload;
    },
  },
});

export const {IncreaseCount, DecreaseCount} = CountSlice.actions
export default CountSlice.reducer
